import { render, staticRenderFns } from "./dormModifyApply.vue?vue&type=template&id=6899d316&scoped=true"
import script from "./dormModifyApply.vue?vue&type=script&lang=js"
export * from "./dormModifyApply.vue?vue&type=script&lang=js"
import style0 from "./dormModifyApply.vue?vue&type=style&index=0&id=6899d316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6899d316",
  null
  
)

export default component.exports